import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { SurveyLayout } from "./SurveyLayout";
import { SurveyRunner } from "./SurveyRunner";

export function SurveyPage({ onLogout }) {
  const { code } = useParams();
  const { t } = useTranslation("common");
  const navigate = useNavigate();

  return (
    <SurveyLayout
      title={t("survey.page_title", "GWBI Survey")}
      subtitle={t("survey.page_subtitle", "Your answers help shape the future of the wine industry.")}
      tagline={t("survey.tagline", "Your voice matters")}
    >
      <SurveyRunner
        code={code}
        sourceContext="direct_link"
        onComplete={() => navigate("/dashboard")}
        onAbandon={() => navigate("/dashboard")}
        variant="dark"
      />
    </SurveyLayout>
  );
}
